/**
 * Return ga client id
 * @return {string} ga client id
 * @deprecated
 */
export const getGaClientId = (): string => {
    const clientId = localStorage.getItem('gaClientId');
    // eslint-disable-next-line no-console
    if (!clientId) console.error("Can't get ga client id");
    return clientId || '';
};

/**
 * Return ga client id using outside call
 *
 * TODO: this is a solution that is not recommended by Google (https://developers.google.com/analytics/devguides/collection/analyticsjs/ga-object-methods-reference), but we need it to test the race, when using the callback to get the clientId for GDL
 * @return {string} ga client id
 */
export const getGaClientIdOutsideCall = (): string => {
    const callbackClientId = getGaClientId();
    if (callbackClientId) return callbackClientId;
    if (typeof window.ga !== 'undefined' && typeof window.ga.getAll === 'function') {
        try {
            return window.ga.getAll()[0].get('clientId');
        } catch (error) {
            window.console.error(`Ga was not loaded. Error: ${error}`);
        }
    }
    return '';
};
